import React, { Fragment, useEffect } from "react";
import DataTable from "../../../../Common/Components/DataTable";
import { useListOfClassManager } from "../Hooks/index";
import Loading from "../../../../Common/Components/Loading";
import CustomModal from "../../../../Common/Components/Modal/CustomModal";
import CommonFrom from "../../../../Common/Components/Form";
import { form } from "./Create";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
function List() {
  const {
    getData,
    data,
    loading,
    deletData,
    showModal,
    setshowModal,
    editUser,
  } = useListOfClassManager();

  useEffect(() => {
    getData();
  }, []);

  const navigate = useNavigate();

  return (
    <Fragment>
      <>
        <DataTable
          loading={loading.getDataLoading}
          heads={[
            {
              title: "نام ",
              key: "fullname",
            },
            {
              title: "شماره موبایل",
              key: "mobile",
            },
            {
              title: "تعداد کلاس",
              key: "class_count",
            },
            {
              title: "وضعیت کاربر",
              key: "status",
              type: "enum",
              enum: {
                active: "فعال",
                dactive: "غیرفعال",
                notpassword: "فعال ",
              },
            },
            {
              title: "زمان ثبت اطلاعات",
              key: "created_at",
              type: "date",
              timetype: "date-time",
            },
          ]}
          textEmpty="برگزار کننده ای ثبت نشده است"
          list={data && data.data}
          data={data}
          links={[
            {
              function: selected => {
                deletData({ client_id: selected[0] });
              },
              color: "danger",
              size: "col-md-2",
              html: "حذف",
              multi: true,
              type: "delete",
            },
            {
              function: selected => {
                setshowModal(selected[0]);
              },
              color: "info",
              size: "col-md-2",
              html: "ویرایش",
              multi: true,
              type: "edit",
            },
            {
              function: selected => {
                navigate({
                  pathname: `/Admin/Classes/List/${selected[0]}`,
                });
              },
              color: "success",
              size: "col-md-3",
              html: "مشاهده کلاسها",
              multi: true,
              type: "show",
              main: true,
            },
          ]}
        />
        <CustomModal
          show={showModal}
          handleClose={() => {
            setshowModal(false);
          }}
          header={"ویرایش اطلاعات کاربر"}
        >
          <CommonFrom
            loading={loading.edit}
            form={form}
            btnName={"ویرایش اطلاعات برگزار کننده"}
            value={data && data.data.filter(user => user.id == showModal)[0]}
            submit={editUser}
          />
        </CustomModal>
      </>
    </Fragment>
  );
}

export default List;
